import { useState } from "react";
import { useParams } from "react-router-dom";
import { Layout } from "antd";
import Highcharts from "highcharts";

import { GET } from "../../../providers/useAxiosQuery";
import ScorecardGraph from "../../../providers/ScorecardGraph";

require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/variable-pie")(Highcharts);
require("highcharts/modules/no-data-to-display")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/offline-exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);
require("highcharts/modules/boost")(Highcharts);

export default function PageScoreCardGraph() {
	const { code } = useParams();

	const [graphResult, setGraphResult] = useState([]);

	GET(
		`api/scorecard_result?code=${code}&from=graph`,
		"scorecard_result_graph",
		async (res) => {
			if (res && res.data) {
				let data = res.data;
				let findForm = data[0];

				if (findForm) {
					let form_question_answer_batches =
						findForm.form_question_answer_batches;
					let form_question_answer_batch = form_question_answer_batches.length
						? form_question_answer_batches[0]
						: null;
					let form_question_answers =
						form_question_answer_batch?.form_question_answers || [];

					let pluckedCategories = form_question_answers.reduce(
						(acc, answer) => {
							let form_question_category_id = answer.form_question_category_id;
							if (!acc.includes(form_question_category_id)) {
								acc.push(form_question_category_id);
							}
							return acc;
						},
						[]
					);

					let form_question_categories = findForm.form_question_categories
						?.filter((category) => pluckedCategories.includes(category.id))
						.filter((category) => category.graph_visible === 1);

					let categories = [];

					if (form_question_answer_batch) {
						form_question_categories.forEach((category) => {
							let filter_form_question_answers = form_question_answers.filter(
								(answer) => answer.form_question_category_id === category.id
							);

							let countAnswered = filter_form_question_answers.reduce(
								(acc, answer) =>
									acc + (answer.answer ? Number(answer.answer) * 5 : 0),
								0
							);
							countAnswered =
								countAnswered > 0 && filter_form_question_answers.length
									? countAnswered / filter_form_question_answers.length
									: countAnswered;

							categories.push({
								name: category.category,
								y: countAnswered,
								color: category.graph_color,
							});
						});
					}
					setGraphResult(categories);
				}
			}
		}
	);

	return (
		<Layout.Content>
			<div className="main-content">
				<div className="logo-wrapper">
					<img
						src="/assets/joyalifevertical_green_on_white_transparent.png"
						alt="joyalifevertical_green_on_white_transparent.png"
					/>
				</div>

				{/* <div className="content-title">Joya Life Scorecard Results</div> */}

				{/* <div className="content-description text-center"></div> */}

				<div className="graph-wrapper">
					<ScorecardGraph Highcharts={Highcharts} graphResult={graphResult} />
				</div>
			</div>

			<div className="footer">
				<div>
					<i>Disclaimer:</i>
				</div>
				<br />
				<div>
					<i>
						Nothing in the scorecard is meant to harm, nor provide a specific
						diagnosis or advice at this stage. If you need help, please speak to
						your GP or appropriate expert to get a referral to a qualified
						professional.
					</i>
				</div>
				<br />
				<div className="emergency">
					If you require urgent assistance, please contact lifeline on 13 11 14
					within Australia, or look up your local equivalent outside of
					Australia.
				</div>
			</div>
		</Layout.Content>
	);
}
